import React, { Fragment } from 'react'
import Component from 'components/component'
import page from 'hoc/page'
import frontload from 'hoc/frontload'
import { DI } from 'modules'
import HelmetWrap from 'components/helmet-wrap'

import {
  CompanyDetailsEn,
  CompanyDetailsMapEn,
} from 'submodules/translations/static-pages/company-details/en'
import {
  CompanyDetailsAr,
  CompanyDetailsMapAr,
} from 'submodules/translations/static-pages/company-details/ar'

import 'submodules/responsivestyles/src/less/company-details.less'

class CompanyDetails extends Component {
  static preload(props) {
    const slug = 'company-details'
    return props.actions.frontpages.getFrontPage(slug)
  }

  render() {
    const meta_tag = this.props.frontpages.info.payload.meta_tag
    const { locale, strings } = this.props.common

    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="company-details" />

        <section className="content">
          <div className="wrap">
            <div className="company-details__title">
              {strings['footer.link.company-details']}
            </div>

            <div className="company-details-block">
              <div className="company-details-block__inner">
                {locale === 'en' && (
                  <div>
                    <CompanyDetailsEn />
                    <CompanyDetailsMapEn />
                  </div>
                )}

                {locale === 'ar' && (
                  <div>
                    <CompanyDetailsAr />
                    <CompanyDetailsMapAr />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default page(DI(['frontpages', 'common'])(frontload(CompanyDetails)))
